import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  background-color: ${(p) => p.theme.palette.common.white};
  max-width: ${(p) => p.theme.spacing(178)};
  border-radius: ${(p) => p.theme.spacing(1)};
  margin: auto;
  margin-top: ${(p) => p.theme.spacing(1)};
  padding: ${(p) => p.theme.spacing(6, 4)};
  gap: ${(p) => p.theme.spacing(6)};
`;

export const Thin = styled(Typography)`
  font-weight: 300;
`;
